var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopulationCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0884 17.0854V9.71484",
    stroke: "#2A2A2A",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.476 6.44276C11.8198 7.89445 10.8092 8.97025 10.3624 9.36775C10.298 9.42269 10.2236 9.46142 10.1442 9.48121C10.0649 9.50101 9.9826 9.5014 9.90311 9.48235C9.33536 9.36126 7.96957 8.92026 7.64781 7.47778C7.3147 6.10532 7.99348 4.21852 8.36551 3.33938C8.39101 3.27288 8.43046 3.21405 8.4806 3.16774C8.53073 3.12142 8.59012 3.08896 8.65385 3.07303C8.71758 3.0571 8.78383 3.05816 8.84712 3.07612C8.9104 3.09408 8.96892 3.12842 9.01782 3.17632C9.72215 3.75798 11.1539 5.07491 11.476 6.44276Z",
    stroke: "#2A2A2A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38908 13.9872C8.30989 14.595 9.27075 13.9842 9.64193 13.697C9.69381 13.6551 9.73678 13.6012 9.76782 13.539C9.79887 13.4768 9.81725 13.4079 9.82167 13.337C9.86349 12.8343 9.86134 11.5919 8.942 11.0046C8.07322 10.4232 6.62871 10.5772 5.94337 10.6957C5.89212 10.7025 5.84305 10.7226 5.80023 10.7545C5.7574 10.7863 5.72205 10.829 5.69709 10.8789C5.67213 10.9289 5.65828 10.9847 5.65668 11.0417C5.65508 11.0987 5.66578 11.1553 5.68789 11.2069C5.93216 11.9255 6.52104 13.416 7.38908 13.9872Z",
    stroke: "#2A2A2A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6109 13.9872C11.6901 14.595 10.7293 13.9842 10.3581 13.697C10.3062 13.6551 10.2632 13.6012 10.2322 13.539C10.2011 13.4768 10.1828 13.4079 10.1783 13.337C10.1365 12.8343 10.1387 11.5919 11.058 11.0046C11.9268 10.4232 13.3713 10.5772 14.0566 10.6957C14.1079 10.7025 14.157 10.7226 14.1998 10.7545C14.2426 10.7863 14.278 10.829 14.3029 10.8789C14.3279 10.9289 14.3417 10.9847 14.3433 11.0417C14.3449 11.0987 14.3342 11.1553 14.3121 11.2069C14.0678 11.9255 13.479 13.416 12.6109 13.9872Z",
    stroke: "#2A2A2A",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulationCount);
export default __webpack_public_path__ + "static/media/populationCount.77e7cd2261eb8fa94b1564b0e07bc7ca.svg";
export { ForwardRef as ReactComponent };